<template>
  <v-dialog :value="show" @click:outside="close" max-width="400">
    <v-card>
      <v-card-title class="headline"> {{ header }} </v-card-title>

      <v-card-text v-html="text"></v-card-text>

      <v-card-actions>
        <slot name="actions" :close="close" :confirm="confirm">
          <v-btn color="error" @click="close">{{ $vuetify.lang.t('$vuetify.basic.no') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirm">{{ $vuetify.lang.t('$vuetify.basic.yes') }}</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    header: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close-modal');
    },

    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
